var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      directives: [
        {
          name: "click-outside",
          rawName: "v-click-outside",
          value: _vm.hideEmojiPicker,
          expression: "hideEmojiPicker",
        },
      ],
      staticClass: "textarea-emoji-picker",
      attrs: { id: `loadableContent-comments-${_vm.node.id}` },
    },
    [
      _c("picker", {
        directives: [
          {
            name: "show",
            rawName: "v-show",
            value: _vm.showEmojiPicker,
            expression: "showEmojiPicker",
          },
        ],
        attrs: {
          data: _vm.emojiIndex,
          title: "Pick your emoji...",
          emoji: "point_up",
        },
        on: { select: _vm.addEmoji },
      }),
      _c(
        "span",
        {
          staticClass: "emoji-trigger",
          class: { triggered: _vm.showEmojiPicker },
          on: { click: _vm.toggleEmojiPicker },
        },
        [
          _c(
            "svg",
            {
              staticStyle: { width: "20px", height: "20px" },
              attrs: { viewBox: "0 0 24 24" },
            },
            [
              _c("path", {
                attrs: {
                  fill: "#888888",
                  d: "M20,12A8,8 0 0,0 12,4A8,8 0 0,0 4,12A8,8 0 0,0 12,20A8,8 0 0,0 20,12M22,12A10,10 0 0,1 12,22A10,10 0 0,1 2,12A10,10 0 0,1 12,2A10,10 0 0,1 22,12M10,9.5C10,10.3 9.3,11 8.5,11C7.7,11 7,10.3 7,9.5C7,8.7 7.7,8 8.5,8C9.3,8 10,8.7 10,9.5M17,9.5C17,10.3 16.3,11 15.5,11C14.7,11 14,10.3 14,9.5C14,8.7 14.7,8 15.5,8C16.3,8 17,8.7 17,9.5M12,17.23C10.25,17.23 8.71,16.5 7.81,15.42L9.23,14C9.68,14.72 10.75,15.23 12,15.23C13.25,15.23 14.32,14.72 14.77,14L16.19,15.42C15.29,16.5 13.75,17.23 12,17.23Z",
                },
              }),
            ]
          ),
        ]
      ),
      _c("vs-input", {
        directives: [
          {
            name: "validate",
            rawName: "v-validate",
            value: "required",
            expression: "'required'",
          },
        ],
        ref: "inputTitle",
        staticClass: "inputx",
        class: { input: true },
        attrs: {
          "vs-size": "large",
          color: "#B20564",
          type: "text",
          name: "message",
          placeholder: _vm.$t("dash.posts.overlay.description_placeholder"),
        },
        nativeOn: {
          keyup: function ($event) {
            if (
              !$event.type.indexOf("key") &&
              _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
            )
              return null
            return _vm.onSubmitComment.apply(null, arguments)
          },
        },
        model: {
          value: _vm.message,
          callback: function ($$v) {
            _vm.message = $$v
          },
          expression: "message",
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }